import { createSelector } from 'reselect';
import { getDeviationById } from '../deviations/selectors';
import { getCompositeId } from '../normalizr/schemas/deviation';
import { DeviationResourceType } from '../../types/deviation';
import { CommissionStatusCodes } from '../../types/commissions';
export var getCommissionById = function (state, id) {
    return getDeviationById(state, getCompositeId(DeviationResourceType.COMMISSION, id));
};
export var getIsDeleted = createSelector([getCommissionById], function (deviation) {
    try {
        return (deviation.commission.status === CommissionStatusCodes.STATUS_DELETED);
    }
    catch (e) {
        return false;
    }
});
export var getIsActive = createSelector([getCommissionById, getIsDeleted], function (deviation, isDeleted) {
    try {
        return (!isDeleted &&
            deviation.commission.status === CommissionStatusCodes.STATUS_ACTIVE);
    }
    catch (e) {
        return false;
    }
});
//# sourceMappingURL=selectors.js.map